import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.simpleObservable.subscribe(data => {
      console.log(data);
    });
  }

  simpleObservable = new Observable((observer) => {
    observer.next(["test1","ttt"]);
    observer.next("test2");
    setTimeout( () => {  observer.next("test3"); }, 1000 );
    observer.complete();
  })
  
  
}



// WEBPACK FOOTER //
// ./src/app/components/test/test.component.ts